import { customSx } from "src/utils/styling";

export const summaryBox = {
  ...customSx.threeColumnsgridFilter,
  background: "#eee",
  margin: "8px 0",
  padding: "16px",
  fontSize: "14px !important",
  lineHeight: "normal",

  "div>div": {
    margin: "10px 0",
    lineHeight: "1.27rem",
    color: "#4a90f7",
    fontSize: "14px",
    height: "100%",
  },

  h6: {
    padding: "0px",
    margin: "10px 0",
    fontSize: "14px !important",
    lineHeight: "1.27rem !important",
  },
};

export const specificSweepAmountBox = {
  display: "flex",
  justifyContent: "end",
  ".MuiInputLabel-shrink": {
    display: "none",
  },
  h6: {
    fontSize: "13px !important",
    marginTop: "-10px",
    marginRight: 4,
  },
  "div>div>div": {
    width: 200,
    input: {
      paddingTop: "8px",
    },
  },
};
